angular.module('admin')
  .controller('AgentStreamCtrl', ['$scope', '$state', '$interval', 'HomeActivity', 'UtilService', 'ActivityDictionary'
  , function($scope, $state, $interval, HomeActivity, utils, ActivityDictionary){

    $scope.agentId =  $state.params.id;

    $scope.startDate = moment().subtract(30, 'days').startOf('day').toDate();

  }]);
